export default __webpack_public_path__ + "static/media/DocRx.8edfcc7a.jpg";